module.exports = __webpack_public_path__ + "assets/img/introduceFour.7c7c84ee.png";